(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["text"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.card .text-block').forEach(function(tb) {
    var paras = tb.querySelectorAll('p');
    if (paras.length <= 1) return;
    for (var i = 1; i < paras.length; i++) paras[i].hidden = true;
    var btn = document.createElement('button');
    btn.className = 'kc-read-more-btn';
    btn.textContent = 'Read more';
    var open = false;
    btn.addEventListener('click', function() {
      open = !open;
      for (var i = 1; i < paras.length; i++) paras[i].hidden = !open;
      btn.textContent = open ? 'Read less' : 'Read more';
    });
    paras[0].insertAdjacentElement('afterend', btn);
  });
});
  } catch(e) { console.error(e); }
})();

})();
